import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import _chunk from 'lodash/chunk';

import Item from './components/item';

const propTypes = {
	overflow: PropTypes.array,
	showListOfFilters: PropTypes.bool,
	selectedFilters: PropTypes.array,
	listOfFilters: PropTypes.array,
	showFiltersList: PropTypes.func,
	deleteFilter: PropTypes.func,
	addFilterValue: PropTypes.func,
	deleteFilterValue: PropTypes.func,
	deleteFilterByName: PropTypes.func,
	clearFilterValue: PropTypes.func,
	loadFilterOptions: PropTypes.func,
	toggleInverseFilterValue: PropTypes.func,
	intl: PropTypes.func,
	deleteAllFilters: PropTypes.func,
	toggleFilterBlock: PropTypes.func
};

const FILTERS_IN_ROW_COUNT = 5;

//todo Now display only 5 filters. In future implement horizontal-scroll container.
const Filters = props => (
	<div className="display-flex-column">
		{
			_chunk(props.selectedFilters, FILTERS_IN_ROW_COUNT).map((selectedFiltersChunk, index) =>
				<div key={index} className="display-inline-block">
					<div className="filters-container clearfix">
						{selectedFiltersChunk.map((filter, i) => (
							<Item
								{...props}
								{...filter}
								onAddValue={props.addFilterValue}
								onDeleteValue={props.deleteFilterValue}
								onDeleteItem={props.deleteFilterByName}
								onClearValue={props.clearFilterValue}
								onLoadOptions={props.loadFilterOptions}
								onToggleInverse={props.toggleInverseFilterValue}
								onCloseOptions={props.closeFilterOptionsByName}
								onBlockFilter={props.toggleFilterBlock}
								shouldOpenOptionsByName={props.filters.shouldOpenOptionsByName}
								intl={props.intl}
								key={`${index}_${i}`} />
						))}
					</div>
				</div>
			)
		}
	</div>
);

Filters.propTypes = propTypes;

export default Filters;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/fixed-filters/main.js